import {isNil} from '@megaphonenpm/mputils/src/utils.js';

export class VotesService {
  constructor () {
  }

  /**
   * Returns an array of the indicies of the answers with the most votes for the current scene.
   * For example, if the votes are [55, 3, 72, 31, 72], returns: [2, 4] (indicating that the
   * answers at index 2 and 4 have the most votes (are tied for first place).
   *
   * @returns {number[]} The indices of the answers with the most votes.
   */
  getIndicesOfLeadingAnswers (votes) {
    // If there are no votes or all votes are zero...
    if (isNil(votes) || votes.length === 0 || votes.every(item => item === 0)) {
      // Return an empty array (meaning there are no answers in the lead)
      return [];
    } else {
      let highestVotes = Math.max(...votes);
      return [...votes.keys()].filter(index => votes[index] === highestVotes);
    }
  }
}